
import React from 'react'
import Routers from './Routers/router'

const App = () => {
  return (
    <div>
      <Routers/>
    </div>
  )
}

export default App